import TurndownService from 'turndown'
import MarkdownIt from 'markdown-it'

import underlinePlugin from './underline'

const turndown = new TurndownService()

turndown.addRule('strikethrough', {
	filter: ['del', 's', 'strike'],
	replacement: content => `~~${content}~~`,
}).addRule('underline', {
	filter: ['u'],
	replacement: content => `++${content}++`,
})


const markdownIt = new MarkdownIt()
markdownIt.use(underlinePlugin)

export const htmlToMarkdown = html => turndown.turndown(html)
export const markdownToHtml = md => markdownIt.render(md)

export default {
	fromHtml: htmlToMarkdown,
	toHtml: markdownToHtml,
}
